import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Languages, CheckIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { US as FlagUS, IL as FlagIL } from 'country-flag-icons/react/3x2'

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const switchLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);
  };

  const currentLanguage = i18n.language || "en";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <Languages className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuItem
          onClick={() => switchLanguage("en")}
          className={cn(
            "flex items-center gap-2 cursor-pointer px-4 py-2 rounded-md",
            currentLanguage === "en" && "bg-primary text-primary-foreground font-semibold"
          )}
        >
          <FlagUS className="h-5 w-5" />
          <span>English</span>
          {currentLanguage === "en" && <CheckIcon className="h-4 w-4 ml-auto" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => switchLanguage("he")}
          className={cn(
            "flex items-center gap-2 cursor-pointer px-4 py-2 rounded-md",
            currentLanguage === "he" && "bg-primary text-primary-foreground font-semibold"
          )}
        >
          <FlagIL className="h-5 w-5" />
          <span>עברית</span>
          {currentLanguage === "he" && <CheckIcon className="h-4 w-4 ml-auto" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}